import { Button, Stack, Typography } from '@mui/material';
import noShareCorn from '/@/components/drawing/assets/no-share-corn-1.svg?url';
import { _ } from '/@/locale';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import styles from './styles.module.css';

const DeleteAccount = ({ closePopup, acceptDelete }: { closePopup: () => void; acceptDelete: () => void }) => {
    const onClickCancel = () => {
        mpTrackEvent('Delete account canceled', undefined);
        closePopup();
    };

    return (
        <Stack direction='column' spacing={2} alignItems='center' sx={{ p: 2 }}>
            <img className={styles.image} alt='Imagen de una chala exclamando algo' src={noShareCorn} />
            <Typography color='primary' sx={{ fontSize: (t) => t.typography.h3.fontSize }}>
                {_('Eliminación de Mi Cuenta')}
            </Typography>
            <Typography>
                {_(
                    'La eliminación es definitiva. Si borrás tu cuenta, no podrás recuperar el contenido ni la información compartida en la Plataforma.'
                )}
            </Typography>
            <Button variant='outlined' color='error' onClick={acceptDelete} fullWidth>
                {_('Eliminar Definitivamente')}
            </Button>
            <Button variant='outlined' onClick={onClickCancel} fullWidth>
                {_('Cancelar')}
            </Button>
        </Stack>
    );
};

export default DeleteAccount;
